import { Outlet } from "react-router-dom";

export function LoginLayout() {
  return (
    <div className="flex h-screen">
      <div className="flex w-full flex-col items-center pt-8 md:w-1/2">
        <Outlet />
      </div>
      <img
        className="hidden h-screen object-cover md:block md:w-1/2"
        src="https://swivl-cdn.s3-us-west-1.amazonaws.com/LoginScreenImage.png"
        alt="Hand holding a phone with Swivl app"
      />
    </div>
  );
}
